<template lang="pug">
  #customers-menu
    md-tabs(:md-active-tab="activeTab")
      md-tab(id="tab-customers" md-label="Клиенты" v-bind:to="{ name: 'Customers'}")
      md-tab(id="tab-groups" md-label="Группы" v-bind:to="{ name: 'CustomerGroups'}")
</template>

<script>
  export default {
    name: 'customers-menu',
    data() {
      return {
        title: '',
        activeTab: ''
      }
    },
    watch: {
      '$route'() {
        this.activeTab = 'tab-' + this.$route.meta.tab;
      },
    },
    computed: {},
    created() {
      this.activeTab = 'tab-' + this.$route.meta.tab;
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// menu.vue?51822fd4